import { createContext } from "react";

const enrollmentContext = createContext();

export default enrollmentContext;
